import { render, staticRenderFns } from "./SplashLayout.vue?vue&type=template&id=7e20d415&"
import script from "./SplashLayout.vue?vue&type=script&lang=js&"
export * from "./SplashLayout.vue?vue&type=script&lang=js&"
import style0 from "./SplashLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports